var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useDisclosure, Text } from 'shared/components/ui';
import { useLogoutTimer } from '../AutoLogoutModal/useInactiveTimer';
import { AutoLogoutModal } from '../AutoLogoutModal';
import { MODAL_INACTIVE_MESSAGE_TIME, MODAL_INACTIVE_TITLE, PROMPT_SECONDS } from '../constants';
import { useToken } from 'shared/hooks';
import { useFinishTime } from '../useFinishTime';
import { TimerMinSecs } from '../countdownTimer';
/**
 * Component that displays a logout modal if the user is idle for 80 minutes
 * then if the user is inactive for 10 minutes more it forces a logout
 *
 * Life cycle:
 * 1. user is active
 * 2. user doesn't trigger any ACTIVE_EVENTS in IDLE_TIMEOUT (miliseconds). See constants for specific values.
 * 3. user becomes idle, triggers onPrompt method. PROMPT_TIMEOUT starts.
 * 4. PROMPT_TIMEOUT ends, triggers on Idle
 *
 * 1.a. if the user trigger any ACTIVE_EVENTS, IDLE_TIMEOUT and PROMPT_TIMEOUT restarts. onActive method is triggered.
 *
 * more info on: https://idletimer.dev/docs/api/props
 *
 * @param {inactiveLogoutProps} props Idle timer props without the onIdle and onPrompt action
 */
var InactiveLogout = function (props) {
    // don't render if you are not authenticated
    var token = useToken();
    if (token === null)
        return null;
    var disclosure = useDisclosure();
    var _a = useLogoutTimer(__assign(__assign({}, props), disclosure)), remaining = _a.remaining, close = _a.close, signOut = _a.signOut;
    var finishTime = useFinishTime(remaining);
    var finishTimeMessage = MODAL_INACTIVE_MESSAGE_TIME(finishTime);
    var acknowledgeButton = _jsx(Button, __assign({ onClick: close }, { children: "Stay Signed In" }));
    return (_jsxs(AutoLogoutModal, __assign({}, disclosure, { onClose: close, signOut: signOut, primaryButton: acknowledgeButton, title: MODAL_INACTIVE_TITLE }, { children: [_jsx(Text, __assign({ size: "subtitle" }, { children: finishTimeMessage })), _jsx(Text, __assign({ size: "subtitle" }, { children: remaining <= PROMPT_SECONDS ? _jsx(TimerMinSecs, { time: remaining }) : null }))] })));
};
export { InactiveLogout };
